<template>
  <router-link v-if="show" :to="link">
    <el-tooltip :content="name" placement="right" effect="light">
      <el-button
        type="primary"
        size="medium"
        icon="el-icon-edit-outline"
        circle
      />
    </el-tooltip>
  </router-link>
</template>

<script>
export default {
  name: "ButtonCreate",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      default: "Создать",
    },
    link: {
      type: String,
      default: "create",
    },
  },
};
</script>
